import { render, staticRenderFns } from "./ParagraphBlock.vue?vue&type=template&id=cc7549bc&scoped=true"
import script from "./ParagraphBlock.vue?vue&type=script&lang=js"
export * from "./ParagraphBlock.vue?vue&type=script&lang=js"
import style0 from "./ParagraphBlock.vue?vue&type=style&index=0&id=cc7549bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc7549bc",
  null
  
)

export default component.exports